/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：738
 */

import { I } from "./index__part-0"
import { ne } from "./index__part-4"
import { re } from "./index__part-5"
import { Provider } from /* 16 */"react-redux"
import /* [auto-meaningful-name] */React from /* 0 */"react"
var _a
_a = React.memo(function (e) {
  var /* [auto-meaningful-name] */e$messageWindow = e.messageWindow
  return React.createElement(Provider, {
    store: I
  }, React.createElement(re, null), React.createElement(ne, {
    messageWindow: e$messageWindow
  }))
})
export { _a as a }
export default _a
